<template lang="pug">
.item
  svg-icon(iconClass="ic_download", className="icon")
  a.i_body_l(:href="item.FileURL", target="_blank") {{ item.FileName }}
</template>

<script>
export default {
  name: "Item",
  props: {
    item: Object,
  },
};
</script>

<style lang="scss" scoped>
.item {
  display: block;
}

.icon {
  @include square(24px);
  color: $color_blue_btn_ci;
}

a {
  margin-left: 10px;
  color: $color_black_text;
}

@media (max-width: 767px) {
  .item {
    display: block;
  }

  .icon {
    @include square(30px);
    color: $color_blue_btn_ci;
  }
}

@media (max-width: 575px) {
  .icon {
    @include square(5.2vw);
    min-height: 20px;
    min-width: 20px;
    color: $color_blue_btn_ci;
  }
}
</style>
